import store from './store';
import router from './router'
import { getToken } from './utils/auth'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

const whiteList = ['', '/','/login','/register', '/drugCategory', '/goodDetail/:goodsId', '/explain','/forgetPasswordNew', '/custom/:customId']//路由白名单
router.beforeEach((to, from, next) => {
    store.commit('SET_NAME', localStorage.getItem('username'));
    NProgress.start()
    if(getToken()){//判断是否登录
        if(to.path === '/login/index') {
            next('/')
        }
        else{
            next()
        }
    }else {//如果前往的页面在路由白名单中则进入，否则重定向到登录页
        if(to.matched.find(item => whiteList.indexOf(item.path) > -1)) {
            next()
        } else{
            next('/login')
        }
    }
})

router.afterEach((to) => {
    
    if(to.path !== '/drugCategory') {
        document.getElementById('app').scrollTo(0,0);
    }
    NProgress.done()
})
